export default __webpack_public_path__ + "b174cea.png";